module.exports = __webpack_public_path__ + "img/81.7ba21c11.jpg";